<template>
  <g ref="gPath" @mouseover="handleMouseOver" @mouseleave="handleMouseLeave">
    <path ref="path" :d="dAttr" :style="pathStyle"></path>
    <!-- @click="deleteLink" -->

    <a v-if="show.delete" @mousedown.stop="handleLinkCurve" @click="deleteLink">
      <text text-anchor="middle" :transform="arrowTransform" font-size="35">&times;</text>
    </a>
    <path v-else d="M -1 -1 L 0 1 L 1 -1 z" :style="arrowStyle" :transform="arrowTransform"></path>
  </g>
</template>

<script>
/* eslint-disable vue/no-side-effects-in-computed-properties */
export default {
  name: 'FlowchartLink',
  props: {
    // start point position [x, y]
    start: {
      type: Array,
      default() {
        return [0, 0];
      },
    },
    // end point position [x, y]
    end: {
      type: Array,
      default() {
        return [0, 0];
      },
    },

    id: Number,
    centerX: Number,
    centerY: Number,
    nodes: Object,
    links: Array,
    scale: Number,
    giveFromNodetoLink: Object,
  },
  data() {
    return {
      show: {
        delete: false,
      },
      newStart: [],
      newEnd: [],
      haveTarget: false,
    };
  },
  methods: {
    handleLinkCurve() {
      // this.$emit("handleLinkCurve", this.id);
    },
    handleMouseOver() {
      if (this.id !== '') {
        this.show.delete = true;
      }
    },
    handleMouseLeave() {
      this.show.delete = false;
    },
    caculateCenterPoint() {
      // caculate arrow position: the center point between start and end

      const dx = (this.newEnd[0] - this.newStart[0]) / 2;
      const dy = (this.newEnd[1] - this.newStart[1]) / 2;

      // const dx = (this.newEnd[0] - this.newStart[0]) / 2;
      // const dy = (this.newEnd[1] - this.newStart[1]) / 2;
      return [this.newStart[0] + dx, this.newStart[1] + dy];
    },
    caculateRotation() {
      // caculate arrow rotation

      const angle = -Math.atan2(this.end[0] - this.start[0], this.end[1] - this.start[1]);
      const degree = (angle * 180) / Math.PI;
      return degree < 0 ? degree + 360 : degree;
    },
    deleteLink() {
      this.$emit('deleteLink');
    },
  },
  computed: {
    pathStyle() {
      return {
        stroke: 'rgb(255, 136, 85)',
        strokeWidth: 2.73205,
        fill: 'none',
        // markerMid: "url(#marker)"
      };
    },

    arrowStyle() {
      return {
        stroke: 'rgb(255, 136, 85)',
        strokeWidth: 5.73205,
        fill: 'none',
      };
    },
    arrowTransform() {
      const [arrowX, arrowY] = this.caculateCenterPoint();
      const degree = this.caculateRotation();
      return `translate(${arrowX}, ${arrowY}) rotate(${degree})`;
    },
    dAttr() {
      // let ox = this.centerX + this.y;
      let target;
      let fromId;
      let toId;

      if (this.id) {
        for (let i = 0; i < this.links.length; i += 1) {
          if (this.links[i].id === this.id) {
            target = this.links[i];
            break;
          }
        }
        // 如果沒有target
        if (!target) {
          console.log('如果沒有target');
          this.haveTarget = false;
          return;
        }
        this.haveTarget = true;
        fromId = target.from;
        toId = target.to;
      } else {
        fromId = this.giveFromNodetoLink.id;
      }

      const cx = this.start[0];
      const cy = this.start[1];
      const ex = this.end[0];
      const ey = this.end[1];
      // (this.scale - 1)

      const newCx = (cx - (this.nodes[fromId].x + this.centerX)) * 0 + cx;

      const newCy = (cy - (this.nodes[fromId].y + this.centerY)) * 0 + cy;

      const newEx = this.id ? (ex - (this.nodes[toId].x + this.centerX)) * 0 + ex : ex;

      const newEy = this.id ? (ey - (this.nodes[toId].y + this.centerY)) * 0 + ey : ey;

      this.newStart = [newCx, newCy];
      this.newEnd = [newEx, newEy];

      // eslint-disable-next-line consistent-return
      return `M ${newCx}, ${newCy} L ${newCx + 10}, ${newCy} C ${newCx
        + 10
        + 73} ${newCy}, ${newEx - 10 - 73} ${newEy},${newEx - 10} ${newEy} L ${newEx} ${newEy} `;
    },
  },
};
</script>

<style scoped lang="scss">
g {
  cursor: pointer;
}
</style>
